import React, { FC } from 'react';

type IconSize = 'sm' | 'md' | 'lg';

interface Props {
  size: IconSize;
}

const InfoIcon: FC<Props> = ({ size }) => {
  const getSize = (size: IconSize) => {
    switch (size) {
      case 'sm':
        return 15;
      case 'lg':
        return 30;
      case 'md':
      default:
        return 22;
    }
  };

  const sizeNumber = getSize(size);

  return (
      <svg
        viewBox="0 0 22 22"
        style={{
          width: `${sizeNumber}px`,
          height: `${sizeNumber}px`,
        }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 22C4.934 22 0 17.065 0 11S4.934 0 11 0s11 4.934 11 11c0 6.065-4.934 11-11 11Zm1.058-16.32c0-.564-.456-1.02-1.019-1.02h-.079a1.019 1.019 0 0 0 0 2.038h.08c.562 0 1.018-.456 1.018-1.019ZM11 8.935c.584 0 1.058.474 1.058 1.058v6.288a1.058 1.058 0 1 1-2.116 0V9.994c0-.584.473-1.058 1.058-1.058Z"
          fill="#00A88D"
        />
      </svg>
  );
};

export default InfoIcon;
